(() => {
  function arproUi(key, fallback, values) {
    var translations = window.arproI18n;
    var template = translations && Object.prototype.hasOwnProperty.call(translations, key) && typeof translations[key] === "string" && translations[key]
      ? translations[key] : fallback;
    return String(template).replace(/\{([A-Za-z][A-Za-z0-9_]*)\}/g, function (match, name) {
      return values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
    });
  }

  const initialized = new WeakSet();
  const normalized = (value) => (value || "").trim().toLocaleLowerCase("fr").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const init = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);

    const grid = root.querySelector("[data-arpro-export-grid]");
    const items = Array.from(root.querySelectorAll("[data-arpro-export-item]"));
    const search = root.querySelector("[data-arpro-export-search]");
    const brand = root.querySelector("[data-arpro-export-brand]");
    const category = root.querySelector("[data-arpro-export-category]");
    const sort = root.querySelector("[data-arpro-export-sort]");
    const reset = root.querySelector("[data-arpro-export-reset]");
    const result = root.querySelector("[data-arpro-export-result]");
    const empty = root.querySelector("[data-arpro-export-empty]");
    const dialog = root.querySelector("[data-arpro-export-selection-dialog]");
    const openSelection = root.querySelector("[data-arpro-export-selection-open]");
    const closeSelection = root.querySelector("[data-arpro-export-selection-close]");
    const selectionList = root.querySelector("[data-arpro-export-selection-list]");
    const selectionCount = root.querySelector("[data-arpro-export-selection-count]");
    const selectionStatus = root.querySelector("[data-arpro-export-selection-status]");
    const announcer = root.querySelector("[data-arpro-export-announcer]");
    const copy = root.querySelector("[data-arpro-export-copy]");
    const request = root.querySelector("[data-arpro-export-request]");
    const clear = root.querySelector("[data-arpro-export-clear]");
    const contact = root.querySelector("[data-arpro-export-contact]");
    const storageKey = root.dataset.arproExportStorageKey || "arpro:export-quote-selection:v1";
    const maximum = 24;
    if (!grid || !dialog) return;

    const options = (select, values) => {
      [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"))
        .forEach((value) => select?.append(new Option(value, normalized(value))));
    };
    options(brand, items.map((item) => item.dataset.brand));
    options(category, items.map((item) => item.dataset.category));

    const read = () => {
      try {
        const value = JSON.parse(sessionStorage.getItem(storageKey) || "[]");
        return Array.isArray(value) ? value.filter((entry) => entry && typeof entry.handle === "string").slice(0, maximum) : [];
      } catch (_error) { return []; }
    };
    let selection = read();
    const write = () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify(selection)); } catch (_error) { /* UI remains usable. */ }
    };
    const announce = (message) => {
      if (selectionStatus) selectionStatus.textContent = message;
      if (announcer) announcer.textContent = message;
    };
    const selectionText = () => selection.map((entry, index) => `${index + 1}. ${entry.name} — ${entry.brand} — ${entry.category}`).join("\n");

    const renderSelection = () => {
      const handles = new Set(selection.map((entry) => entry.handle));
      root.querySelectorAll("[data-arpro-export-select]").forEach((button) => {
        const active = handles.has(button.closest("[data-arpro-export-item]")?.dataset.handle);
        button.setAttribute("aria-pressed", String(active));
        button.textContent = active ? arproUi("js_residual_082", "Retirer de ma sélection") : arproUi("js_residual_083", "Ajouter à ma sélection");
      });
      if (selectionCount) selectionCount.textContent = String(selection.length);
      if (openSelection) openSelection.disabled = selection.length === 0;
      if (copy) copy.disabled = selection.length === 0;
      if (request) request.disabled = selection.length === 0;
      if (clear) clear.disabled = selection.length === 0;
      if (selectionList) {
        selectionList.replaceChildren(...selection.map((entry) => {
          const line = document.createElement("li");
          const copyBlock = document.createElement("span");
          const title = document.createElement("strong");
          const detail = document.createElement("small");
          const remove = document.createElement("button");
          title.textContent = entry.name;
          detail.textContent = `${entry.brand} · ${entry.category}`;
          copyBlock.append(title, detail);
          remove.type = "button";
          remove.textContent = arproUi("js_residual_084", "Retirer");
          remove.setAttribute("aria-label", arproUi("js_residual_089", "Retirer {name} de la sélection", { name: entry.name }));
          remove.addEventListener("click", () => {
            selection = selection.filter((candidate) => candidate.handle !== entry.handle);
            write(); renderSelection();
          });
          line.append(copyBlock, remove);
          return line;
        }));
      }
    };

    root.querySelectorAll("[data-arpro-export-select]").forEach((button) => button.addEventListener("click", () => {
      const item = button.closest("[data-arpro-export-item]");
      if (!item) return;
      const existing = selection.some((entry) => entry.handle === item.dataset.handle);
      if (existing) {
        selection = selection.filter((entry) => entry.handle !== item.dataset.handle);
        announce(arproUi("js_residual_090", "{name} retiré de la sélection.", { name: item.dataset.name }));
      } else if (selection.length < maximum) {
        selection.push({
          handle: item.dataset.handle,
          name: item.dataset.name,
          brand: item.dataset.brand,
          category: item.dataset.category
        });
        announce(arproUi("js_residual_091", "{name} ajouté à la sélection.", { name: item.dataset.name }));
      }
      else { announce(arproUi("js_residual_092", "La sélection est limitée à {maximum} références par demande.", { maximum: maximum })); return; }
      write(); renderSelection();
    }));

    const applyFilters = () => {
      const query = normalized(search?.value);
      const wantedBrand = brand?.value || "";
      const wantedCategory = category?.value || "";
      let visible = 0;
      items.forEach((item) => {
        const matches = (!query || normalized(item.dataset.search).includes(query))
          && (!wantedBrand || normalized(item.dataset.brand) === wantedBrand)
          && (!wantedCategory || normalized(item.dataset.category) === wantedCategory);
        item.hidden = !matches;
        if (matches) visible += 1;
      });
      if (result) result.textContent = arproUi("js_residual_093", "{visible} référence{plural} affichée{agreement} sur {total}", { visible: visible, plural: visible > 1 ? "s" : "", agreement: visible > 1 ? "s" : "", total: items.length });
      if (empty) empty.hidden = visible !== 0;
    };
    const applySort = () => {
      const mode = sort?.value || "catalogue";
      const ordered = [...items].sort((a, b) => {
        if (mode === "name") return a.dataset.name.localeCompare(b.dataset.name, "fr");
        if (mode === "brand") return a.dataset.brand.localeCompare(b.dataset.brand, "fr") || a.dataset.name.localeCompare(b.dataset.name, "fr");
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      ordered.forEach((item) => grid.append(item));
    };
    [search, brand, category].forEach((control) => control?.addEventListener("input", applyFilters));
    sort?.addEventListener("change", () => { applySort(); applyFilters(); });
    reset?.addEventListener("click", () => {
      if (search) search.value = "";
      if (brand) brand.value = "";
      if (category) category.value = "";
      if (sort) sort.value = "catalogue";
      applySort(); applyFilters();
    });

    const openDialog = () => {
      try { dialog.showModal(); } catch (_error) { dialog.setAttribute("open", ""); }
      closeSelection?.focus();
    };
    const closeDialog = () => dialog.open && typeof dialog.close === "function" ? dialog.close() : dialog.removeAttribute("open");
    openSelection?.addEventListener("click", openDialog);
    closeSelection?.addEventListener("click", closeDialog);
    dialog.addEventListener("cancel", (event) => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener("click", (event) => { if (event.target === dialog) closeDialog(); });

    clear?.addEventListener("click", () => { selection = []; write(); renderSelection(); announce(arproUi("js_residual_085", "Sélection vidée.")); });
    copy?.addEventListener("click", async () => {
      if (!selection.length) return;
      try { await navigator.clipboard.writeText(selectionText()); announce(arproUi("js_residual_086", "Sélection copiée.")); }
      catch (_error) { announce(arproUi("js_residual_087", "Copie indisponible dans ce navigateur. Sélectionnez les lignes ci-dessus.")); }
    });
    request?.addEventListener("click", () => {
      if (!selection.length) return;
      const onboarding = document.querySelector("[data-arpro-pro-onboarding]");
      if (!onboarding) {
        announce(arproUi("js_residual_088", "Sélection prête. Copiez-la ou ouvrez le formulaire de contact Export."));
        contact?.focus();
        return;
      }
      onboarding.dispatchEvent(new CustomEvent("arpro:quote-selection-updated", { detail: { items: selection } }));
      closeDialog();
      onboarding.dispatchEvent(new CustomEvent("arpro:onboarding-open-request", { detail: { trigger: openSelection || request } }));
    });

    applySort(); applyFilters(); renderSelection();
  };

  const initAll = (scope = document) => scope.querySelectorAll("[data-arpro-export-catalogue]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
